export default __webpack_public_path__ + "static/media/brewing.b08067b0.jpg";